import { useCallback } from 'react';
import { DocumentField } from 'Interfaces/DocumentFields';

import useDocumentFieldUpdateLocally from './useDocumentFieldUpdateLocally';

interface SetDocumentFieldStyles {
  (documentField: DocumentField): void;
}

export default () => {
  const updateDocumentFieldLocally = useDocumentFieldUpdateLocally();

  const setDocumentFieldsStyles: SetDocumentFieldStyles = useCallback(
    (documentField: DocumentField) => {
      const updatedField = {
        ...documentField,
        style: {
          ...documentField.style,
          width: documentField.width as number,
          height: documentField.height as number,
          left: documentField.coordinateX,
          top: documentField.coordinateY,
          fontFamily: documentField.fontFamily || undefined,
          fontSize: documentField.fontSize ? documentField.fontSize : undefined,
        },
      };

      updateDocumentFieldLocally(updatedField);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [updateDocumentFieldLocally],
  );

  return setDocumentFieldsStyles;
};
